import { Leaf } from "lucide-react";

const scrollTo = (e, href) => {
  e.preventDefault();
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -108 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-ink py-14 text-cream/70">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col items-start justify-between gap-8 sm:flex-row sm:items-center">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-forest text-cream">
              <Leaf size={17} />
            </span>
            <span className="font-serif text-lg font-semibold text-cream">
              Nutrição Zero ao <span className="italic text-ochre">Equilíbrio</span>
            </span>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
            <a href="#metodo" data-testid="footer-link-metodo" onClick={(e) => scrollTo(e, "#metodo")} className="transition-colors hover:text-cream">O Método</a>
            <a href="#capitulos" data-testid="footer-link-capitulos" onClick={(e) => scrollTo(e, "#capitulos")} className="transition-colors hover:text-cream">Capítulos</a>
            <a href="#autora" data-testid="footer-link-autora" onClick={(e) => scrollTo(e, "#autora")} className="transition-colors hover:text-cream">Autora</a>
            <a href="#oferta" data-testid="footer-link-oferta" onClick={(e) => scrollTo(e, "#oferta")} className="transition-colors hover:text-cream">Oferta</a>
          </nav>
        </div>
        <div className="mt-10 border-t border-white/10 pt-8">
          <p className="max-w-3xl text-xs leading-relaxed text-cream/50">
            Aviso: este material tem caráter educativo e não substitui consulta,
            diagnóstico ou acompanhamento individualizado com nutricionista ou médico.
          </p>
          <p className="mt-4 text-xs text-cream/50">
            © 2026 Jessica Montenegro — Nutricionista. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
